export const COMPROT_PROCESSOS = {
  "codigoRetorno": "",
  "mensagem": "",
  "processos": [
    {
      "numeroProcesso": "10293720481202545",
      "numeroProcessoEditado": "10293.720481/2025-45",
      "nomeAssunto": "ABANDONO DE CARGOS/DEMISSAO",
      "dataUltimaMovimentacao": [
        2025,
        4,
        29
      ]
    },
    {
      "numeroProcesso": "10293720473202507",
      "numeroProcessoEditado": "10293.720473/2025-07",
      "nomeAssunto": "ABANDONO DE CARGOS/DEMISSAO",
      "dataUltimaMovimentacao": [
        2025,
        4,
        25
      ]
    },
    {
      "numeroProcesso": "10293720398202576",
      "numeroProcessoEditado": "10293.720398/2025-76",
      "nomeAssunto": "ABANDONO DE CARGOS/DEMISSAO",
      "dataUltimaMovimentacao": [
        2025,
        4,
        11
      ]
    },
    {
      "numeroProcesso": "10293720402202504",
      "numeroProcessoEditado": "10293.720402/2025-04",
      "nomeAssunto": "ABANDONO DE CARGOS/DEMISSAO",
      "dataUltimaMovimentacao": [
        2025,
        4,
        11
      ]
    },
    {
      "numeroProcesso": "10805720009202595",
      "numeroProcessoEditado": "10805.720009/2025-95",
      "nomeAssunto": "ABANDONO DE CARGOS/DEMISSAO",
      "dataUltimaMovimentacao": [
        2025,
        1,
        28
      ]
    },
    {
      "numeroProcesso": "10805720109202431",
      "numeroProcessoEditado": "10805.720109/2024-31",
      "nomeAssunto": "ABANDONO DE CARGOS/DEMISSAO",
      "dataUltimaMovimentacao": [
        2024,
        9,
        13
      ]
    },
    {
      "numeroProcesso": "10830720015202454",
      "numeroProcessoEditado": "10830.720015/2024-54",
      "nomeAssunto": "ABANDONO DE CARGOS/DEMISSAO",
      "dataUltimaMovimentacao": [
        2024,
        7,
        4
      ]
    },
    {
      "numeroProcesso": "10830720016202407",
      "numeroProcessoEditado": "10830.720016/2024-07",
      "nomeAssunto": "ABANDONO DE CARGOS/DEMISSAO",
      "dataUltimaMovimentacao": [
        2024,
        7,
        4
      ]
    },
    {
      "numeroProcesso": "10805720049202456",
      "numeroProcessoEditado": "10805.720049/2024-56",
      "nomeAssunto": "ABANDONO DE CARGOS/DEMISSAO",
      "dataUltimaMovimentacao": [
        2024,
        7,
        3
      ]
    },
    {
      "numeroProcesso": "10805720050202481",
      "numeroProcessoEditado": "10805.720050/2024-81",
      "nomeAssunto": "ABANDONO DE CARGOS/DEMISSAO",
      "dataUltimaMovimentacao": [
        2024,
        7,
        3
      ]
    },
    {
      "numeroProcesso": "10805720051202425",
      "numeroProcessoEditado": "10805.720051/2024-25",
      "nomeAssunto": "ABANDONO DE CARGOS/DEMISSAO",
      "dataUltimaMovimentacao": [
        2024,
        7,
        3
      ]
    },
    {
      "numeroProcesso": "10805720052202470",
      "numeroProcessoEditado": "10805.720052/2024-70",
      "nomeAssunto": "ABANDONO DE CARGOS/DEMISSAO",
      "dataUltimaMovimentacao": [
        2024,
        7,
        3
      ]
    },
    {
      "numeroProcesso": "10805720053202414",
      "numeroProcessoEditado": "10805.720053/2024-14",
      "nomeAssunto": "ABANDONO DE CARGOS/DEMISSAO",
      "dataUltimaMovimentacao": [
        2024,
        7,
        3
      ]
    },
    {
      "numeroProcesso": "10805720054202469",
      "numeroProcessoEditado": "10805.720054/2024-69",
      "nomeAssunto": "ABANDONO DE CARGOS/DEMISSAO",
      "dataUltimaMovimentacao": [
        2024,
        7,
        3
      ]
    },
    {
      "numeroProcesso": "10805720055202411",
      "numeroProcessoEditado": "10805.720055/2024-11",
      "nomeAssunto": "ABANDONO DE CARGOS/DEMISSAO",
      "dataUltimaMovimentacao": [
        2024,
        7,
        3
      ]
    },
    {
      "numeroProcesso": "10830720014202418",
      "numeroProcessoEditado": "10830.720014/2024-18",
      "nomeAssunto": "ABANDONO DE CARGOS/DEMISSAO",
      "dataUltimaMovimentacao": [
        2024,
        6,
        28
      ]
    },
    {
      "numeroProcesso": "10830720010202421",
      "numeroProcessoEditado": "10830.720010/2024-21",
      "nomeAssunto": "ABANDONO DE CARGOS/DEMISSAO",
      "dataUltimaMovimentacao": [
        2024,
        6,
        25
      ]
    },
    {
      "numeroProcesso": "10830720011202476",
      "numeroProcessoEditado": "10830.720011/2024-76",
      "nomeAssunto": "ABANDONO DE CARGOS/DEMISSAO",
      "dataUltimaMovimentacao": [
        2024,
        6,
        25
      ]
    },
    {
      "numeroProcesso": "10830720030202311",
      "numeroProcessoEditado": "10830.720030/2023-11",
      "nomeAssunto": "RESTITUICAO - ASSUNTOS TRIBUTARIOS DIVERSOS",
      "dataUltimaMovimentacao": [
        2023,
        12,
        15
      ]
    },
    {
      "numeroProcesso": "10830720029202397",
      "numeroProcessoEditado": "10830.720029/2023-97",
      "nomeAssunto": "RESTITUICAO - IOF",
      "dataUltimaMovimentacao": [
        2023,
        12,
        13
      ]
    },
    {
      "numeroProcesso": "10830720022202375",
      "numeroProcessoEditado": "10830.720022/2023-75",
      "nomeAssunto": "ABANDONO DE CARGOS/DEMISSAO",
      "dataUltimaMovimentacao": [
        2023,
        9,
        25
      ]
    },
    {
      "numeroProcesso": "10830720020202386",
      "numeroProcessoEditado": "10830.720020/2023-86",
      "nomeAssunto": "ABANDONO DE CARGOS/DEMISSAO",
      "dataUltimaMovimentacao": [
        2023,
        9,
        22
      ]
    },
    {
      "numeroProcesso": "10805720033202362",
      "numeroProcessoEditado": "10805.720033/2023-62",
      "nomeAssunto": "ABANDONO DE CARGOS/DEMISSAO",
      "dataUltimaMovimentacao": [
        2023,
        9,
        13
      ]
    },
    {
      "numeroProcesso": "10805720022202382",
      "numeroProcessoEditado": "10805.720022/2023-82",
      "nomeAssunto": "ABANDONO DE CARGOS/DEMISSAO",
      "dataUltimaMovimentacao": [
        2023,
        8,
        30
      ]
    },
    {
      "numeroProcesso": "10805720023202327",
      "numeroProcessoEditado": "10805.720023/2023-27",
      "nomeAssunto": "ABANDONO DE CARGOS/DEMISSAO",
      "dataUltimaMovimentacao": [
        2023,
        8,
        30
      ]
    },
    {
      "numeroProcesso": "10805720024202371",
      "numeroProcessoEditado": "10805.720024/2023-71",
      "nomeAssunto": "ABANDONO DE CARGOS/DEMISSAO",
      "dataUltimaMovimentacao": [
        2023,
        8,
        30
      ]
    },
    {
      "numeroProcesso": "10805720025202316",
      "numeroProcessoEditado": "10805.720025/2023-16",
      "nomeAssunto": "ABANDONO DE CARGOS/DEMISSAO",
      "dataUltimaMovimentacao": [
        2023,
        8,
        30
      ]
    },
    {
      "numeroProcesso": "10805720026202361",
      "numeroProcessoEditado": "10805.720026/2023-61",
      "nomeAssunto": "ABANDONO DE CARGOS/DEMISSAO",
      "dataUltimaMovimentacao": [
        2023,
        8,
        30
      ]
    },
    {
      "numeroProcesso": "10805720027202313",
      "numeroProcessoEditado": "10805.720027/2023-13",
      "nomeAssunto": "ABANDONO DE CARGOS/DEMISSAO",
      "dataUltimaMovimentacao": [
        2023,
        8,
        30
      ]
    },
    {
      "numeroProcesso": "10805720021202338",
      "numeroProcessoEditado": "10805.720021/2023-38",
      "nomeAssunto": "ABANDONO DE CARGOS/DEMISSAO",
      "dataUltimaMovimentacao": [
        2023,
        8,
        29
      ]
    },
    {
      "numeroProcesso": "10875720033202339",
      "numeroProcessoEditado": "10875.720033/2023-39",
      "nomeAssunto": "ABANDONO DE CARGOS/DEMISSAO",
      "dataUltimaMovimentacao": [
        2023,
        8,
        29
      ]
    },
    {
      "numeroProcesso": "10320720023202370",
      "numeroProcessoEditado": "10320.720023/2023-70",
      "nomeAssunto": "PER - ELETRONICO - PAGAMENTO A MAIOR OU INDEVIDO",
      "dataUltimaMovimentacao": [
        2023,
        8,
        22
      ]
    },
    {
      "numeroProcesso": "10320720024202314",
      "numeroProcessoEditado": "10320.720024/2023-14",
      "nomeAssunto": "DCOMP - ELETRONICO - SALDO NEGATIVO DO CSLL",
      "dataUltimaMovimentacao": [
        2023,
        8,
        22
      ]
    },
    {
      "numeroProcesso": "10540720013202340",
      "numeroProcessoEditado": "10540.720013/2023-40",
      "nomeAssunto": "PER - ELETRONICO - SALDO NEGATIVO DO CSLL",
      "dataUltimaMovimentacao": [
        2023,
        8,
        17
      ]
    },
    {
      "numeroProcesso": "10805720020202393",
      "numeroProcessoEditado": "10805.720020/2023-93",
      "nomeAssunto": "ABANDONO DE CARGOS/DEMISSAO",
      "dataUltimaMovimentacao": [
        2023,
        8,
        8
      ]
    },
    {
      "numeroProcesso": "10830720018202315",
      "numeroProcessoEditado": "10830.720018/2023-15",
      "nomeAssunto": "ABANDONO DE CARGOS/DEMISSAO",
      "dataUltimaMovimentacao": [
        2023,
        7,
        21
      ]
    },
    {
      "numeroProcesso": "10830720017202362",
      "numeroProcessoEditado": "10830.720017/2023-62",
      "nomeAssunto": "ABANDONO DE CARGOS/DEMISSAO",
      "dataUltimaMovimentacao": [
        2023,
        7,
        20
      ]
    },
    {
      "numeroProcesso": "10830720015202373",
      "numeroProcessoEditado": "10830.720015/2023-73",
      "nomeAssunto": "ABANDONO DE CARGOS/DEMISSAO",
      "dataUltimaMovimentacao": [
        2023,
        6,
        7
      ]
    },
    {
      "numeroProcesso": "10830403438200973",
      "numeroProcessoEditado": "10830.403438/2009-73",
      "nomeAssunto": "PEDIDO DE PARCELAMENTO NA INTERNET-ASSUNTOS TRIBUTARIOS",
      "dataUltimaMovimentacao": [
        2009,
        11,
        19
      ]
    },
    {
      "numeroProcesso": "10830006453200896",
      "numeroProcessoEditado": "10830.006453/2008-96",
      "nomeAssunto": "PEDIDO DE INCLUSAO NO SIMPLES NACIONAL LC 123 DE 2006",
      "dataUltimaMovimentacao": [
        2008,
        10,
        10
      ]
    }
  ]
}